import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4); /* oscuro translúcido */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  flex-direction: column;
`;

const Spinner = styled.div`
  border: 8px solid #f3f3f3;
  border-top: 8px solid #007bff;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  animation: ${spin} 1s linear infinite;
`;

const Text = styled.p`
  margin-top: 15px;
  color: #fff;
  font-weight: bold;
  font-size: 1rem;
`;

const FullScreenSpinner = ({ text = "Procesando, por favor espere..." }) => (
  <Overlay>
    <Spinner />
    <Text>{text}</Text>
  </Overlay>
);

export default FullScreenSpinner;
